// @flow @format
import React from 'react';

import type { Contest } from '../redux/reducer/entities';
import type { ContestType } from '../redux/types';
import IndexPage from './common/IndexPage';

const fieldTitles = {
  ice: 'ワゴンで うりに いこう',
  pizza: 'おすすめの ピザを つくろう',
  sushi: '売れるおすしを考えよう',
  'ice-a': 'アイスクリームを仕入れて売ろう',
  'pizza-a': '本日のピザを売ろう',
  'sushi-a': '売れるおすしを予想しよう'
};

type Props = {
  contestType: ContestType,
  contest: Contest
};

export const ContestIndexPage = ({ contestType, contest }: Props) => (
  <IndexPage kind={contestType} contest={contest} fieldTitle={fieldTitles[contestType]} />
);

export default ContestIndexPage;
